export default __webpack_public_path__ + "static/2147-b1a4ac045aad8d4ea6024d9e29ac371a.gif";